import React from "react";

export default function DamatexCageCard({ cage, onTogglePresence, onToggleSubSensor, onCalDateChange, onCalNeededChange, onOpenCalibration }) {
  return (
    <div className={`damatex-cage-card ${cage.calibrationNeeded ? "calibration-needed" : ""}`}>
      <div className="damatex-header">
        <span className="damatex-title">Damatex Cage</span>
        <label style={{ fontSize: 13, cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={cage.present}
            onChange={(e) => onTogglePresence(e.target.checked)}
            style={{ marginRight: 6 }}
          />
          Present
        </label>
      </div>

      {cage.present && (
        <>
          <div className="sub-sensor-list">
            {["temp", "humidity", "co2"].map((key) => (
              <label key={key} className="sub-sensor-checkbox">
                <input
                  type="checkbox"
                  checked={cage.subSensors[key]}
                  onChange={(e) => onToggleSubSensor(key, e.target.checked)}
                />
                {key === "co2" ? "CO2" : key.charAt(0).toUpperCase() + key.slice(1)}
              </label>
            ))}
          </div>

          <div className="calibration-section">
            <label style={{ fontSize: 13, display: "block", marginBottom: 4 }}>Last Calibration Date</label>
            <input
              type="date"
              className="calibration-date-input"
              value={cage.lastCalDate || ""}
              onChange={(e) => onCalDateChange(e.target.value || null)}
            />
            <label className="sub-sensor-checkbox" style={{ marginTop: 8, color: cage.calibrationNeeded ? "#ef4444" : "inherit" }}>
              <input
                type="checkbox"
                checked={cage.calibrationNeeded}
                onChange={(e) => onCalNeededChange(e.target.checked)}
              />
              Calibration Needed
            </label>
            {cage.calibrationNeeded && onOpenCalibration && (
              <button
                className="calibrate-btn"
                onClick={onOpenCalibration}
              >
                Open Calibration Form
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
